export const getCategoryByName = async (categoryName: string) => {
  const response = await fetch(
    `/api/bigcommerce/catalog/getCategoryByName/?categoryName=${categoryName}`
  )
  const { data } = await response.json()
  return data
}
